<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew bg-gradient-warning bg-image-treek">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-7">
                <h3 class="display-3 text-white">{{reference.name}}, {{reference.role}} {{$t('general.at')}}
                  {{reference.company }}:</h3>
                <br>
                <h2 class="display-1 text-white">&quot;{{ $t('reference.' + reference.slug + '.summary') }}&quot;</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <section class="section section-lg mt--100 mb--100">
      <div class="container">
        <div class="row row-grid justify-content-center">
          <div class="col-lg-8 text-center">
            <h2 class="display-3">&quot;{{ $t('reference.' + reference.slug + '.para1') }}&quot;</h2>
            <p class="lead">{{ reference.name }}, {{ reference.role }} {{$t('general.at')}} {{ reference.company }}</p>
            <div
              v-if="reference.url"
              class="btn-wrapper">
              <a
                :href="reference.url"
                target="_blank"
                class="btn btn-primary mt-3">
                {{ $t('reference.button.text') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import referenceData from '../data/references.js';
  import listUtils from "../lib/listUtils";

  export default {
    name: "reference",
    computed: {
      reference() {
        return listUtils.findBySlug(this.$route.params.id, referenceData)
      }
    }
  };
</script>
